import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';
import { useLoginPopup } from '@theme/js/components/popups/LoginPopup';
import { useNavigate } from '@theme/js/hooks/navigate';
import { useUserSelector } from '@core/js/store/hooks';

import * as urlUtils from '@theme/js/utils/url.util';

export const useUrlParams = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const { pathname } = useLocation();
    const navigateWithReplace = useNavigate({ replace: true });
    const showLoginPopup = useLoginPopup();
    const openLoginOnTop = urlUtils.getLocationParam('openLoginOnTop');
    const openLogin = urlUtils.getLocationParam('openLogin');

    useEffect(() => {
        if (!isLoggedIn && (openLoginOnTop || openLogin)) {
            showLoginPopup();
            navigateWithReplace(pathname, null, { removeParams: ['openLoginOnTop', 'openLogin'] });
        } else if (isLoggedIn && (openLoginOnTop || openLogin)) {
            navigateWithReplace(pathname, null, { removeParams: ['openLoginOnTop', 'openLogin'] });
        }
    }, [isLoggedIn, pathname, navigateWithReplace, openLoginOnTop, showLoginPopup, openLogin]);
};
